import { render, staticRenderFns } from "./TabDettaglioNote.vue?vue&type=template&id=6c5492b1&"
import script from "./TabDettaglioNote.vue?vue&type=script&lang=js&"
export * from "./TabDettaglioNote.vue?vue&type=script&lang=js&"
import style0 from "./TabDettaglioNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabDettaglioNote.vue
// module id = 779
// module chunks = 0